import useWindowSize from "./useWindowSize";

const useIsMobile = (): boolean => {
  const size = useWindowSize();

  return size.width <= 480;
};

export default useIsMobile;
